/*
 * NiCOCHiLL — Microsoft Clarity カスタム計測層
 * ---------------------------------------------------------------------------
 * 役割:
 *   ベースタグ（= Clarity 公式 Shopify アプリが注入する window.clarity）に対して、
 *   「このストア固有の文脈」をタグとイベントで足す。録画とヒートマップだけでは
 *   分からない次の3つを見えるようにするのが目的。
 *     1. どのセグメント（フレーバー / 種別 / 流入 / 会員）で落ちているのか
 *     2. 購入導線のどの一手で止まったのか（カート追加 → レジ）
 *     3. こちらが仕掛けたブロック（120mL上限・発売前）が実際に何回踏まれたか
 *
 * なぜベースタグを自前で入れないのか:
 *   ベースタグは Clarity 公式 Shopify アプリの担当。ここはアプリの有無に関係なく
 *   「window.clarity があれば乗る / 無ければ黙って何もしない」という作りにして、
 *   将来アプリを外して手動タグに戻しても、このファイルはそのまま動くようにする。
 *
 * 失敗時の方針:
 *   計測が原因で購入導線を壊さないこと。あらゆる副作用を try/catch で包み、
 *   fetch は「見るだけ」で握り替えない（下の wrapFetch のコメント参照）。
 *
 * 前提ファイル:
 *   snippets/nc-clarity-context.liquid   … #nc-clarity-context（サーバー側の文脈JSON）
 *   assets/nc-ml-guard.js                … nc:ml-limit-blocked イベントの発火元
 *   snippets/nicochill-pdp-sticky.liquid … nc:cart:added イベントの発火元
 */
(function () {
  'use strict';

  if (typeof window === 'undefined' || typeof document === 'undefined') return;
  if (window.__ncClarityInstalled) return;
  window.__ncClarityInstalled = true;

  // テーマエディタのプレビューは「客の行動」ではないので計測しない。
  try {
    if (window.Shopify && window.Shopify.designMode) return;
  } catch (e) {}

  /* ---------- Clarity への送信口 ---------- */

  // 公式アプリのタグは読み込み直後に window.clarity をキュー関数として定義するが、
  // アプリ埋め込みの読み込み順は保証されない。見つかるまで待って、
  // それまでの呼び出しはこちら側で貯めておく。
  var pending = [];
  var api = null;

  function flush() {
    while (pending.length) {
      var a = pending.shift();
      try { api.apply(null, a); } catch (e) {}
    }
  }

  function send() {
    var a = Array.prototype.slice.call(arguments);
    if (api) { try { api.apply(null, a); } catch (e) {} return; }
    if (pending.length < 200) pending.push(a);   // タグが永久に来ない場合に備えた上限
  }

  (function waitForClarity() {
    var tries = 0;
    var timer = setInterval(function () {
      tries++;
      if (typeof window.clarity === 'function') {
        api = window.clarity;
        clearInterval(timer);
        flush();
      } else if (tries > 75) {                   // 200ms × 75 = 15秒であきらめる
        clearInterval(timer);
        pending.length = 0;
      }
    }, 200);
  })();

  // Clarity の3つのAPI。set は絞り込み用の軸、event はスマートイベント、
  // upgrade は「この録画は必ず残す」という指定（サンプリングで消えると困るものだけ）。
  function tag(key, value) {
    if (value === null || value === undefined || value === '') return;
    send('set', key, String(value));
  }
  function event(name) { send('event', name); }
  function upgrade(reason) { send('upgrade', reason); }

  /* ---------- 文脈の読み取り ---------- */

  function readContext() {
    try {
      var el = document.getElementById('nc-clarity-context');
      if (!el) return null;
      return JSON.parse(el.textContent || el.innerText || '{}');
    } catch (e) { return null; }
  }

  var ctx = readContext() || {};

  /* ---------- 流入元の判定 ---------- */

  // Clarity の標準リファラだけだと LINE / メールが「direct」に潰れる。
  // 施策ごとの効き目を見たいので、こちらで名前を付ける。
  function entrySource() {
    try {
      var q = new URLSearchParams(window.location.search);
      // ?nl= は LINE(LIFF) からの着地（snippets/nicochill-line-capture.liquid）
      if (q.get('nl')) return 'line';
      var utm = (q.get('utm_source') || '').toLowerCase();
      if (utm) {
        if (utm.indexOf('line') >= 0) return 'line';
        if (utm.indexOf('mailchimp') >= 0 || utm.indexOf('mail') >= 0) return 'mail';
        return utm.slice(0, 24);
      }
      if (q.get('mc_cid') || q.get('mc_eid')) return 'mail';   // Mailchimp の既定パラメータ
      var ref = document.referrer || '';
      if (!ref) return 'direct';
      var host = '';
      try { host = new URL(ref).hostname; } catch (e) { return 'other'; }
      if (host === window.location.hostname) return 'internal';
      if (/line\.me|liff\./.test(host)) return 'line';
      if (/google\.|yahoo\.|bing\./.test(host)) return 'search';
      if (/x\.com|twitter\.|instagram\.|facebook\.|t\.co/.test(host)) return 'social';
      return host.slice(0, 32);
    } catch (e) { return 'unknown'; }
  }

  // 流入は「最初に着地したときの1回」が本当の流入元。回遊で direct に
  // 上書きされないよう、セッション中は最初の判定を持ち回る。
  function stickyEntry() {
    var KEY = 'nc_clarity_entry';
    try {
      var saved = sessionStorage.getItem(KEY);
      if (saved) return saved;
      var v = entrySource();
      if (v === 'internal') return 'direct';
      sessionStorage.setItem(KEY, v);
      return v;
    } catch (e) { return entrySource(); }
  }

  /* ---------- 帯にまとめる ---------- */

  // 送料は 〜9,999=¥4,000 / 10,000〜14,999=¥2,000 / 15,000〜=無料 の3段階。
  // （2026-10-14 に ¥5,000/¥3,000 から改定。それ以前のタグ値は fee5000/fee3000）
  // 「どの段で止まっているカートが多いか」がそのまま次のナッジ施策になるので、
  // 金額そのものではなく段で持つ。
  // 送料の判定に使う金額。規則の正本は line-bot/lib/shipping-rate.js:
  // 半額クーポン(50OFF_RICHILL)のときだけ割引前の商品合計、それ以外は割引後の金額。
  function shippingBasisYen(ctx) {
    var net = Number(ctx.cartYen) || 0;
    var gross = Number(ctx.cartYenGross) || 0;
    var discount = gross - net;
    var halfOff = gross > 0 && discount > 0 && Math.abs(discount / gross - 0.5) <= 0.01;
    return halfOff ? gross : net;
  }

  function shippingTier(yen) {
    if (!yen) return 'empty';
    if (yen >= 15000) return 'free';
    if (yen >= 10000) return 'fee2000';
    return 'fee4000';
  }

  function cartBucket(items) {
    if (!items) return '0';
    if (items === 1) return '1';
    if (items <= 3) return '2-3';
    if (items <= 5) return '4-5';
    return '6+';
  }

  /* ---------- 初期タグ ---------- */

  function applyTags() {
    tag('nc_template', ctx.template || 'unknown');
    tag('nc_customer', ctx.customer || 'guest');
    tag('nc_entry', stickyEntry());
    tag('nc_cart_items', cartBucket(Number(ctx.cartItems) || 0));
    tag('nc_ship_tier', shippingTier(shippingBasisYen(ctx)));
    tag('nc_device', window.innerWidth < 750 ? 'mobile' : 'desktop');

    if (ctx.pageHandle) tag('nc_page', ctx.pageHandle);
    if (ctx.collectionHandle) tag('nc_collection', ctx.collectionHandle);

    var p = ctx.product;
    if (p) {
      tag('nc_product', p.handle);
      tag('nc_ptype', p.ptype);
      tag('nc_flavor', p.flavor);
      tag('nc_price', String(p.yen));
      tag('nc_soon', p.soon ? 'yes' : 'no');
      tag('nc_available', p.available ? 'yes' : 'no');
    }
  }

  applyTags();

  /* ---------- カート操作の観測 ---------- */

  // 見るだけのラッパ。元の promise はそのまま呼び出し元に返し、
  // 観測は派生 promise（捨てる）の中でやる。ここで throw しても
  // 呼び出し元のカート追加には一切影響しない。
  //
  // 読み込み順は nc-ml-guard.js → nc-clarity.js なので、このラッパは
  // ガードの外側に付く。つまりガードが合成した 422（上限/発売前ブロック）も
  // 「レスポンス」として観測できる。ブロックの内訳は
  // nc:ml-limit-blocked の方が正確なので、ここでは ok の追加だけ拾う。
  var addedThisPage = false;

  function onCartAdd(res) {
    if (!res || !res.ok) return;                 // 422 系は nc:ml-limit-blocked が拾う
    if (addedThisPage) return;                   // 1ページ1回で十分（連打を数えない）
    addedThisPage = true;
    event('nc_add_to_cart');
    if (ctx.product && ctx.product.ptype) event('nc_add_' + ctx.product.ptype);
  }

  function wrapFetch() {
    if (typeof window.fetch !== 'function') return;
    var orig = window.fetch;
    window.fetch = function (input, init) {
      var out = orig.apply(this, arguments);
      try {
        var url = '';
        if (typeof input === 'string') url = input;
        else if (input && input.url) url = input.url;
        if (/\/cart\/add(\.js)?(\?|$)/.test(url)) {
          out.then(function (res) {
            try { onCartAdd(res); } catch (e) {}
          }, function () { /* 通信失敗は Clarity 標準の指標側で見る */ });
        }
      } catch (e) {}
      return out;
    };
  }

  wrapFetch();

  // pdp-sticky（商品ページの追随バー）は自前 fetch で追加したあとに通知を出す。
  // 上の wrapFetch でも拾えるが、取りこぼし対策に両方見る（addedThisPage で重複しない）。
  document.addEventListener('nc:cart:added', function () {
    try { onCartAdd({ ok: true }); } catch (e) {}
  });

  /* ---------- こちらが仕掛けたブロックの観測 ---------- */

  // 「買えなかった」は録画で必ず見たい。サンプリングで消えないよう upgrade する。
  document.addEventListener('nc:ml-limit-blocked', function (e) {
    try {
      var reason = (e && e.detail && e.detail.reason) || 'ml';
      if (reason === 'soon') {
        event('nc_blocked_soon');
        upgrade('nc_blocked_soon');
      } else {
        event('nc_blocked_ml_limit');
        upgrade('nc_blocked_ml_limit');
      }
      tag('nc_blocked', reason);
    } catch (err) {}
  });

  /* ---------- 購入導線のクリック ---------- */

  // 委譲で1本にまとめる。DOM が差し替わる（カートの Section Rendering、
  // モーダルの生成）ので、要素に直接付けると外れる。
  var fired = {};
  function once(name, upgradeToo) {
    if (fired[name]) return;
    fired[name] = true;
    event(name);
    if (upgradeToo) upgrade(name);
  }

  document.addEventListener('click', function (ev) {
    try {
      var t = ev.target;
      if (!t || !t.closest) return;

      // レジへ進む（購入導線の最終手前。ここまで来た人と来ない人を分ける軸）
      if (t.closest('[name="checkout"], form[action*="/checkout"] button, .nc-checkout-btn')) {
        once('nc_checkout_click', true);
        return;
      }
      // 商品ページの追随購入バー
      if (t.closest('.nc-psticky')) { once('nc_click_sticky_buy'); return; }
      // トップのフローティングCTA
      if (t.closest('.nc-fcta')) { once('nc_click_floating_cta'); return; }
      // 年齢確認の直後に出す初めての方LPを閉じた（見ずに閉じた人と読んだ人を分ける軸）
      if (t.closest('[data-nc-slp-close]')) { once('nc_starter_lp_close'); return; }
      // カート内アドオンピッカー（送料ナッジのモーダルから足す動線）
      if (t.closest('.nc-addon, .nc-addons__tab')) { once('nc_click_cart_addon'); return; }
      // 購入方法ページ・初めての方LPへの誘導
      if (t.closest('a[href*="/pages/how-to-buy"], a[href*="/pages/starter"]')) {
        once('nc_click_howto');
        return;
      }
    } catch (e) {}
  }, true);

  // 年齢確認のチェック（ここで止まる人がいるかを見る）
  document.addEventListener('change', function (ev) {
    try {
      var t = ev.target;
      if (!t) return;
      if (t.id === 'age-verification-checkbox' && t.checked) once('nc_age_confirmed');
      if (t.closest && t.closest('.nc-fsel')) once('nc_flavor_selected');
    } catch (e) {}
  }, true);

  // 年齢確認の直後に初めての方LPが出た（出た人と、そこから何をしたかを追う起点）
  document.addEventListener('nc:starter-lp-shown', function () { once('nc_starter_lp_shown'); });

  /* ---------- AIに相談（assets/nc-ai-consult.js が投げる） ----------
     view は必ず取ること。無いと「出ているのに押されない」と「そもそも出ていない」を
     区別できず、押されない原因がコピーなのか設置場所なのか永久に分からなくなる。
     view は DOM にあることではなく“実際に見える状態になった”ときに1回だけ飛ぶ
     （右下固定は初期状態が opacity:0 / pointer-events:none なので、
       単純な IntersectionObserver では出ていないのに view が立つ）。
     click の飛び先はイベント名に混ぜず nc_ai_consult_target の軸で分ける。
     Clarity のイベント名は増やすほどダッシュボードが読みにくくなるため。 */
  document.addEventListener('nc:ai-consult:view', function () { once('nc_ai_consult_view'); });
  document.addEventListener('nc:ai-consult:open', function () { once('nc_ai_consult_open'); });
  document.addEventListener('nc:ai-consult:click', function (ev) {
    try {
      var target = ev && ev.detail && ev.detail.target;
      if (target) tag('nc_ai_consult_target', target);
    } catch (e) {}
    once('nc_ai_consult_click');
  });

  // 送料ナッジのモーダルが開いたか（body に nc-modal-open が付く）
  try {
    new MutationObserver(function () {
      if (document.body.classList.contains('nc-modal-open')) once('nc_shipping_modal_open');
    }).observe(document.body, { attributes: true, attributeFilter: ['class'] });
  } catch (e) {}

  /* ---------- 読了深度 ---------- */

  // LP と商品ページは縦に長い。「どこまで読まれたか」はヒートマップでも見えるが、
  // イベントにしておくとセグメント（フレーバー別・流入別）で比較できる。
  (function scrollDepth() {
    var marks = [50, 90];
    function onScroll() {
      try {
        var max = document.documentElement.scrollHeight - window.innerHeight;
        if (max <= 0) return;
        var pct = Math.round((window.scrollY / max) * 100);
        for (var i = 0; i < marks.length; i++) {
          if (pct >= marks[i]) once('nc_scroll_' + marks[i]);
        }
        if (fired['nc_scroll_90']) window.removeEventListener('scroll', onScroll);
      } catch (e) {}
    }
    window.addEventListener('scroll', onScroll, { passive: true });
  })();

  /* ---------- 機微箇所のマスク ---------- */

  // Liquid 側で data-clarity-mask を付けられない分（ライブ限定ファイル・
  // Dawn 標準セクション）をここで補う。Clarity はキャプチャ時に属性を見るので、
  // 後から付けても効く。
  (function maskSensitive() {
    var SELECTORS = [
      '.nc-receipt',                 // 領収書（適格簡易請求書）
      '.nc-account', '.nc-order',    // マイページ / 注文詳細
      '.customer',                   // Dawn 標準の顧客系セクション
      '.address', '[name="address"]'
    ];
    function apply() {
      try {
        var nodes = document.querySelectorAll(SELECTORS.join(','));
        for (var i = 0; i < nodes.length; i++) {
          if (!nodes[i].hasAttribute('data-clarity-mask')) {
            nodes[i].setAttribute('data-clarity-mask', 'true');
          }
        }
      } catch (e) {}
    }
    apply();
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply);
  })();
})();
